import './App.css';
import RoutesPage from './routes';

function App() {

  return (
    <div className="App">
      <RoutesPage  />
    </div>
  );
}

export default App;
